import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { SectionLabel, MaskedHeading, Reveal } from "@/components/site/Motion";

const IMAGES = [
  {
    url: "https://images.pexels.com/photos/32616619/pexels-photo-32616619.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
    span: "md:col-span-5 md:row-span-2",
    h: "h-[380px] md:h-full",
  },
  {
    url: "https://images.unsplash.com/photo-1470225620780-dba8ba36b745?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    span: "md:col-span-7",
    h: "h-[280px] md:h-[300px]",
  },
  {
    url: "https://images.unsplash.com/photo-1756981168649-0e3c3c8a32f3?crop=entropy&cs=srgb&fm=jpg&q=85&w=700",
    span: "md:col-span-4",
    h: "h-[280px]",
  },
  {
    url: "https://images.unsplash.com/photo-1517774729239-58be8e8875cc?crop=entropy&cs=srgb&fm=jpg&q=85&w=700",
    span: "md:col-span-3",
    h: "h-[280px]",
  },
];

const Frame = ({ img, i }) => (
  <Reveal delay={i * 0.08} className={img.span}>
    <div className={`group relative overflow-hidden ${img.h}`}>
      <img
        src={img.url}
        alt="VIP1 performance"
        className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-110"
      />
      <div className="absolute inset-0 bg-obsidian/30 group-hover:bg-obsidian/10 transition-colors duration-500" />
      <div className="absolute inset-0 ring-1 ring-inset ring-white/10 group-hover:ring-brand/50 transition-colors duration-500" />
      <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-obsidian/80 to-transparent" />
    </div>
  </Reveal>
);

export const Gallery = () => {
  const { t } = useLang();
  return (
    <section id="gallery" className="py-24 md:py-36 px-6 md:px-12 max-w-[1600px] mx-auto">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
        <div>
          <SectionLabel>{t.gallery.overline}</SectionLabel>
          <h2 className="font-heading text-4xl md:text-6xl text-white tracking-tight">
            <MaskedHeading text={t.gallery.title} />
          </h2>
        </div>
        <Reveal delay={0.15}>
          <p className="font-body text-white/55 max-w-sm md:text-right">{t.gallery.desc}</p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-5 md:auto-rows-[300px]">
        {IMAGES.map((img, i) => (
          <Frame key={i} img={img} i={i} />
        ))}
      </div>
    </section>
  );
};
